/**
 * @file ppde页精选项目
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useMemo} from 'react';
import {Col, Row} from 'antd';
import FeaturedCasesItem from './FeaturedCasesItem';
import {IFeaturedCaseProps} from './types';

const FeaturedCases: React.FC<IFeaturedCaseProps> = (props) => {
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);

    const [
        firstItem,
        restList
    ] = useMemo(() => {
        return [
            list[0],
            list.slice(1, 7)
        ];
    }, [list]);

    const [
        firstXsSpan,
        restXsSpan,
        restSubXsSpan,
        restSubRow
    ] = useMemo(() => {
        if (list.length === 1) {
            return [24, 0, 0, 0];
        }
        if (list.length === 2) {
            return [12, 12, 24, 1];
        }
        if (list.length === 3) {
            return [12, 12, 24, 2];
        }
        if (list.length === 4) {
            return [6, 18, 8, 1];
        }
        if (list.length === 5) {
            return [8, 16, 12, 2];
        }
        return [6, 18, 8, 2];
    }, [list]);

    return (
        <div className="paddle-ppde-fc">
            <Row gutter={10}>
                <Col xs={firstXsSpan}>
                    {!!firstItem
                    && (
                        <FeaturedCasesItem size="large" {...firstItem} />
                    )}
                </Col>
                <Col xs={restXsSpan}>
                    <Row gutter={[10, 10]}>
                        {restList.map((item, index) => (
                            <Col key={index} xs={restSubXsSpan}>
                                <FeaturedCasesItem
                                    size={restSubRow === 1 ? 'large' : undefined}
                                    {...item}
                                />
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default FeaturedCases;
